
console.log("Custom js is working");
var request_page_type = "";
var mega_menu_open = false;

if(window.innerWidth > 640) {
  window.addEventListener("scroll", () => {
    const header = document.querySelector("sticky-header");
  if(request_page_type == 'index') {
    // if(window.pageYOffset > 100 && window.pageYOffset < 950) {
    //   header.setAttribute('hide', true);
    // } else {
    //   header.setAttribute('hide', false);
    // }
  } else {
    // document.querySelector("sticky-header").style.backdropFilter = 'blur(27px)';
  }
  
    if(window.pageYOffset > 900) {
      if(request_page_type != 'product') {
        // document.querySelector("sticky-header").style.backdropFilter = 'blur(27px)';
        document.querySelector("sticky-header").style.background = '#ffffff';
    
        header.setAttribute('dark', true);
    
        // document.querySelector('.header__icon--account').style.display = 'none';
      }
    } else{
     if(request_page_type == 'index' && !document.querySelector("sticky-header").classList.contains('search-focused')) {
      //   document.querySelector("sticky-header").style.backdropFilter = 'blur(0px)';
      //  header.style.background = 'transparent';

      //  document.querySelector("sticky-header").style.backdropFilter = 'blur(27px)';
        document.querySelector("sticky-header").style.background = '#ffffff';
    
        header.setAttribute('dark', true);
       
     }
     if(mega_menu_open == false) {
       if(request_page_type == 'index' && !document.querySelector("sticky-header").classList.contains('search-focused')) {
        header.setAttribute('dark', true);
       } else {
         header.setAttribute('dark', true);
       }
       } else {
       header.setAttribute('dark', true);
       }
        // document.querySelector('.header__icon--account').style.display = 'block';
    }
  })
}

// document.querySelectorAll(".menu-drawer__menu-item").forEach((item, index) => {
//   item.addEventListener("click", () => {
//     document.querySelector(".menu-drawer__menu-item[aria-expanded='true']")
//       if(item != item_1) {
//         item_1.closest(".menu-drawer__close-button").click();
//       }
    
//   })
// })

function initMenuDrawerTabs(root = document) {
  root.querySelectorAll(".menu-drawer__tabs").forEach((tabs) => {
    tabs.querySelectorAll(".menu-drawer__tab").forEach((tabButton) => {
      if (tabButton.dataset.tabBound === "true") return;
      tabButton.dataset.tabBound = "true";

      tabButton.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();

        const targetTab = tabButton.getAttribute("data-tab");
        const scope = tabs.closest(".menu-drawer__submenu") || tabs.parentElement;
        const activePanel = scope.querySelector(".menu-drawer__tab-panel:not([hidden])");
        const nextPanel = scope.querySelector(`.menu-drawer__tab-panel[data-tab-panel="${targetTab}"]`);

        if (!nextPanel || nextPanel === activePanel) return;

        tabs.querySelectorAll(".menu-drawer__tab").forEach((btn) => {
          btn.setAttribute("aria-selected", btn === tabButton ? "true" : "false");
        });

        const showNextPanel = () => {
          nextPanel.hidden = false;
          requestAnimationFrame(() => {
            nextPanel.classList.remove("menu-drawer__tab-panel--switching");
          });
        };

        if (activePanel) {
          activePanel.classList.add("menu-drawer__tab-panel--switching");
          nextPanel.classList.add("menu-drawer__tab-panel--switching");

          activePanel.addEventListener(
            "transitionend",
            () => {
              activePanel.hidden = true;
              activePanel.classList.remove("menu-drawer__tab-panel--switching");
              showNextPanel();
            },
            { once: true }
          );
        } else {
          nextPanel.classList.add("menu-drawer__tab-panel--switching");
          showNextPanel();
        }
      });
    });
  });
}

initMenuDrawerTabs();

document.addEventListener("shopify:section:load", (event) => {
  initMenuDrawerTabs(event.target);
});

document.querySelectorAll(".menu-drawer__menu details").forEach((item) => {
  item.addEventListener("toggle", () => {
    if (item.open) {
      mega_menu_open = true;
      console.log("menu is open");

      const others = Array.from(document.querySelectorAll(".menu-drawer__menu details"))
        .filter(detail => detail !== item);

      others.forEach((other) => {
        if (other.open) {
          let summaryItem = other.querySelector('summary');
          other.removeAttribute("open"); // This closes it without triggering another toggle
          summaryItem.setAttribute('aria-expanded', false);
        }
      });

    } else {
      mega_menu_open = false;
      console.log("menu is closed");
    }
  });
});


if(window.innerWidth <= 640) {
  window.addEventListener("scroll", () => {
    const header = document.querySelector("sticky-header");
    if(request_page_type == 'index') {
      if(window.pageYOffset > 400) {
      
  
      header.setAttribute('dark', true);
      // header.style.backdropFilter = 'blur(27px)';
      header.style.background = '#ffffff';
    } else{
      //  header.style.backdropFilter = 'blur(0px)';
      //   header.style.background = 'transparent';
       
      //    header.setAttribute('dark', false);
      }
    } else if(request_page_type != 'product'){
      header.setAttribute('dark', true);
      // header.style.backdropFilter = 'blur(27px)';
      header.style.background = '#ffffff';
    }
  })
}


document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector("sticky-header");
  if(request_page_type != 'product') {
     header.setAttribute('dark', true);
    // header.style.backdropFilter = 'blur(27px)';
    header.style.background = '#ffffff';
  } else {
    header.style.background = 'transparent';
  }
});


document.querySelector(".header__icon--menu")?.addEventListener("click", (e) => {
   const header = document.querySelector("sticky-header");
  setTimeout(() => {
    const status = document.querySelector(".header__icon--menu").getAttribute("aria-expanded");
    if(status == 'true') {
      console.log("menu drawer opened");
      document.querySelector(".custom-header-icons").classList.add("menu-open");
      header.style.removeProperty('backdrop-filter');
      header.style.background = '#ffffff';
      header.setAttribute('dark', true);
    } else {
        document.querySelector(".custom-header-icons").classList.remove("menu-open");
      if(request_page_type == 'index') {
         console.log("menu drawer closed");
          header.setAttribute('dark', true);
        //  if(window.pageYOffset > 400) {
        //     header.style.backdropFilter = 'blur(27px)';
        //    header.style.background = '#ffffff54';
        //     header.setAttribute('dark', true);
        //  }
        // header.style.backdropFilter = 'blur(27px)';
           header.style.background = '#ffffff';
            header.setAttribute('dark', true);
      } else {
          // header.style.backdropFilter = 'blur(27px)';
           header.style.background = '#ffffff';
            header.setAttribute('dark', true);
      }
     
    }
  }, 50)
});


// if(request_page_type == 'index') {
//   document.querySelector(".header__heading-logo-wrapper img").style.opacity = '0';
// }


    class ProductCardSlider extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }

    connectedCallback() {
      this.slider = this.querySelector('[id^="Slider-"]');
      this.nextBtn = this.querySelector('.swiper-button-next');
      this.prevBtn = this.querySelector('.swiper-button-prev');

      if (!this.slider) return;
      this.initPages();

      const resizeObserver = new ResizeObserver(() => this.initPages());
      resizeObserver.observe(this.slider);

      if(window.innerWidth > 989 ) {
        this.addEventListener('mouseenter', this.onHoverNextSlide.bind(this));
        this.addEventListener('mouseleave', this.resetSlider.bind(this));
      }
    }

    initPages() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
      this.swiper = new Swiper(this, {
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          type: 'progressbar',
        },
        navigation: {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev'),
        },
        allowTouchMove: true,
        effect: 'fade',
        fadeEffect: { crossFade: true },
        speed: 500,
        loop: false,
        breakpoints: {
          990: {
            allowTouchMove: true,
          },
        },
      });
    }

    
    onHoverNextSlide() {
      if (this.dataset.showHover === 'false') return;
      if (this.dataset.swatchActive === 'true') return;
      if (!this.swiper || this.swiper.slides.length < 2) return;
      this.swiper.slideTo(1, 400);
    }

    resetSlider() {
      if (this.dataset.showHover === 'false') return;
      if (this.dataset.swatchActive === 'true') return;
      if (!this.swiper) return;
      this.swiper.slideTo(0, 400);
    }

  }

  // window.addEventListener("DOMContentLoaded", () => {
  //   document.querySelector(".swiper-pagination-progressbar-fill").style.transform = "translate3d(0px, 0px, 0px) scaleX(0.5) scaleY(1)";
  // })

  customElements.define('product-card-slider', ProductCardSlider);

  // ── Swatch hover/click — runs on ALL product cards across every page ──
  function initSwatches(scope) {
    (scope || document).querySelectorAll('.card-wrapper').forEach((card) => {
      const swatches = card.querySelectorAll('.colour-swatch-wrapper');
      if (!swatches.length) return;
      const sliderEl = card.querySelector('product-card-slider');

      // Store slide 1's original src once
      if (sliderEl) {
        const slide1Img = sliderEl.querySelector('.swiper-slide:nth-child(2) img');
        if (slide1Img && !slide1Img.dataset.originalSrc) {
          slide1Img.dataset.originalSrc = slide1Img.src;
          slide1Img.dataset.originalSrcset = slide1Img.srcset;
        }
      }

      // Per-card timer handles so race conditions can be cancelled
      let enterTimer = null;
      let leaveTimer = null;

      swatches.forEach((swatch) => {
        if (swatch.dataset.listenerAttached) return;
        swatch.dataset.listenerAttached = 'true';

        swatch.addEventListener('mouseenter', () => {
          if (!sliderEl || !sliderEl.swiper) return;
          const imgUrl = swatch.getAttribute('data-imgurl');
          if (!imgUrl) return;

          // Cancel any pending leave-restore so it doesn't wipe new image
          clearTimeout(leaveTimer);
          clearTimeout(enterTimer);

          // Always snap to slide 0 instantly first (hides slide 1)
          sliderEl.swiper.slideTo(0, 0);

          // Swap src while slide 1 is hidden, then fade in
          enterTimer = setTimeout(() => {
            const slide1 = sliderEl.swiper && sliderEl.swiper.slides[1];
            if (slide1) {
              const img = slide1.querySelector('img');
              if (img) { img.src = imgUrl; img.srcset = imgUrl + ' 1x, ' + imgUrl + ' 2x'; }
            }
            sliderEl.swiper.slideTo(1, 600);
          }, 50);
        });

        swatch.addEventListener('mouseleave', () => {
          if (!sliderEl || !sliderEl.swiper) return;

          // Cancel any pending enter so it doesn't fight the restore
          clearTimeout(enterTimer);

          sliderEl.swiper.slideTo(0, 600);
          // Restore slide 1 after fade completes
          leaveTimer = setTimeout(() => {
            const slide1 = sliderEl.swiper && sliderEl.swiper.slides[1];
            if (slide1) {
              const img = slide1.querySelector('img');
              if (img && img.dataset.originalSrc) {
                img.src = img.dataset.originalSrc;
                img.srcset = img.dataset.originalSrcset || '';
              }
            }
          }, 650);
        });

        swatch.addEventListener('click', (e) => {
          const productUrl = swatch.getAttribute('data-producturl');
          if (productUrl) { e.preventDefault(); e.stopPropagation(); window.location.href = productUrl; }
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => initSwatches());

  // Re-run when new cards are injected (infinite scroll, sliders, etc.)
  new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.addedNodes.length) { initSwatches(); break; }
    }
  }).observe(document.body, { childList: true, subtree: true });




  // customjs to trim footer newsletter placeholder text
  if(window.innerWidth < 454) {
    const input_width = document.querySelector("#contact_form .field__input").clientWidth;
    const char_to_show = input_width/5.5;
    const placeholder_text = document.querySelector("#contact_form .field__input").getAttribute("placeholder");
    const truncated_text = placeholder_text.substring(0,char_to_show)+"..";
    document.querySelector("#contact_form .field__input").setAttribute("placeholder", truncated_text);
  }


// custom css for brand and bespoke page
    document.querySelectorAll(".shopify-section-group-footer-group").forEach((section, index) => {
      section.classList.add(`scrolling-footer-section-${index+1}`);
    });

    // document.querySelector(".scrolling-footer-section-1").style.marginTop = document.querySelector(".scrolling-footer-section-1").clientHeight+'px';

if(request_page_type == 'index') {
  document.querySelector('.header__search.hide_on_mobile .search__input').addEventListener("focusin", () => {
    document.querySelector('sticky-header').style.background = 'rgba(255, 255, 255, 1)';
    // document.querySelector('sticky-header').style.backdropFilter = 'blur(27px)';
    document.querySelector('sticky-header').setAttribute('dark', true);
    document.querySelector('sticky-header').classList.add('search-focused');
  });
  
  document.querySelector('.header__search.hide_on_mobile .search__input').addEventListener("focusout", () => {
  if(window.pageYOffset < 900) {
    document.querySelector('sticky-header').style.background = 'rgba(255, 255, 255, 0)';
    document.querySelector('sticky-header').style.backdropFilter = 'blur(0px)';
    document.querySelector('sticky-header').setAttribute('dark', true);
    document.querySelector('sticky-header').classList.remove('search-focused');
  }
  })
}